import { render, staticRenderFns } from "./CustomAreaFilter.vue?vue&type=template&id=9285a4e2&lang=pug&"
import script from "./CustomAreaFilter.vue?vue&type=script&lang=js&"
export * from "./CustomAreaFilter.vue?vue&type=script&lang=js&"
import style0 from "./CustomAreaFilter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports